<template>
  <ModalDialog
    ref="dialog"
    title="Select Glass Sheet For Cutting"
    icon="fa-layer-group"
    :showFooter="true"
    :scrollable="true"
    :submitDisabled="!hasSelectedGlass"
    :submitting="submitting"
    submitTitle="Cut Glass"
    @closed="onClosed"
    @submitted="onSubmitted">

    <Spinner v-if="loadingData" />
    <FormGroup v-bind:form="form" :labelColumnSize="3" v-show="!loadingData">
      <h2>{{stockData.code}} - {{stockData.name}}</h2>
      <StaticDataTable class="static-table-list station-table mt-2">
        <template v-slot:header>
          <tr>
            <th>Size (HxW)</th>
            <th>Barcode</th>
            <th>Stock On Hand</th>
            <th>Select</th>
          </tr>
        </template>
        <template v-slot:body>
          <tr v-for="glassLevel in glassLevelList" :key="glassLevel.id" :ref="`glassLevelRow-${glassLevel.id}`" @click.prevent="selectedGlassLevelId = glassLevel.id">
            <td class="font-weight-bold">
              {{glassLevel.height}} x {{glassLevel.width}}
              <LabelBadge labelClass="label-stock-general" v-if="glassLevel.isOffcut">Offcut</LabelBadge>
            </td>
            <td>
              <span v-if="glassLevel.isOffcut">{{glassLevel.barcode}}</span>
              <span v-if="!glassLevel.isOffcut">-</span>
            </td>
            <td>{{glassLevel.qtyOnHand}}</td>
            <td>
              <IconBoolean :value="selectedGlassLevelId == glassLevel.id" :displayFalse="false" />
            </td>
          </tr>
        </template>
        <template v-slot:empty v-if="glassLevelList.length == 0">No glass levels found</template>
      </StaticDataTable>
      <div class="mt-4">
        <h2 v-if="selectedGlassLevelId && selectedGlass" class="text-center">Cut Glass Sheet <strong>{{selectedGlass.height}} x {{selectedGlass.width}}</strong> of <strong>{{stockData.name}}</strong>?</h2>
      </div>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'GlassSheetCuttingDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    stockId: Number,
    glassLevelId: Number,
    productionStageId: Number,
    productionStationId: Number
  },
  data() {
    return {
      loadingData: false,
      stockData: { },
      glassLevelList: [],
      selectedGlassLevelId: null,
      form: {},
      submitting: false
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    selectedGlass() {
      return this.glassLevelList.find(level => level.id == this.selectedGlassLevelId)
    },
    hasSelectedGlass() {
      return this.selectedGlassLevelId != null && this.selectedGlass != null
    }
  },
  methods: {
    show() {
      this.form = {}

      this.submitting = false
      this.stockData = { }
      this.glassLevelList = []

      // Download the stock / glass data
      this.requestStockData()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      // Send cut glass level request
      this.form = this.clearFormResponse()

      this.submitting = true
      this.$apiService.glassProductionStationService.cutGlassLevel(this.productionStationId, this.selectedGlassLevelId, { quantity: 1 })
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },

    requestStockData() {
      this.loadingData = true

      this.$apiService.inventoryService.getStock(this.stockId)
      .then(response => {
        this.stockData = response.data

        // Build the list of glass levels
        this.glassLevelList = []
        if(this.stockData.glassSizeList) {
          this.stockData.glassSizeList.forEach(glassSize => {
            if(glassSize.glassLevels) {
              glassSize.glassLevels.forEach(glassLevel => {
                var levelOutput = _.clone(glassLevel)

                this.glassLevelList.push(levelOutput)
              })
            }
          })
        }
        this.loadingData = false

        if(this.glassLevelId) {
          this.selectedGlassLevelId = this.glassLevelId

          // Attempt to scroll to the selected glass level if automatically set
          this.$nextTick(() => {
            let rowRef = this.$refs[`glassLevelRow-${this.glassLevelId}`][0]
            let dialogRef = this.$refs.dialog
            if(dialogRef && rowRef) {
              dialogRef.scrollToElement(rowRef)
            }
          })
        }

      })
      .catch(err => {
        this.loadingData = false
      })
    },

    cancelCutting() {
      this.modalClosed(null)
      this.hide()
    },
 

  }
}
</script>